/* from: 
    hexToRGB - https://learnersbucket.com/examples/interview/convert-hex-color-to-rgb-in-javascript/
*/
import fullHex from "./fullHex.js";
/**
 *
 * @param {string} hex rgb color in hex
 * @returns {[red, green, blue]} array of RGB
 * @description convert rgb in hex format to rgb array
 */
const hexToRGB = (hex) => {
  if (hex.length === 4) {
    return fullHex(hex);
  }

  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  return [r, g, b];
};
export default hexToRGB;
